module.exports = __webpack_public_path__ + "img/nocode-newsletter.e754e4d.svg";